var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('sc-overlay',{attrs:{"is-centered":true}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":64,"width":4,"color":"primary"}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }